import { CourseCompletionI18n } from "./model";

declare const __ORIGIN_I18N__: CourseCompletionI18n;

export const getI18n = (): CourseCompletionI18n => {
  return __ORIGIN_I18N__;
};
